



















import { ProductDisplayMode } from "@/model/product-display-mode";
import Vue from "vue";

export default Vue.extend({
	name: "ProductItemDisplayModeSelector",
	props: {
		value: {
			type: String,
			required: true
		},
		options: {
			type: Object as () => Array<string>,
			default: [ProductDisplayMode.LIST, ProductDisplayMode.CARD, ProductDisplayMode.ROW]
		}
	},
	watch: {
		value() {
		}
	},
	computed: {
		placeholder(): string {
			const option = this.options.find((option: Readonly<ProductDisplayMode>) => {
				return option === this.value;
			});
			return option || this.options[0];
		}
	},
	data() {
		return <{ isExpanded: boolean, ProductDisplayMode: ProductDisplayMode }>{
			isExpanded: false,
			ProductDisplayMode: ProductDisplayMode
		};
	},
	methods: {
		select(option: string) {
			this.$emit("input", option);
		}
	}
});

